import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4886ef4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "series__wrapper" }
const _hoisted_2 = { class: "ribbons" }
const _hoisted_3 = { class: "series__info" }
const _hoisted_4 = { class: "series__info-title" }
const _hoisted_5 = { class: "series__info-category uppercase" }

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { computed } from 'vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import PreviewPlayer from '@/components/Players/PreviewPlayer.vue'
import { IPlaylistItem } from '@/api'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSeriesSlider',
  props: {
    playlistMedia: {}
  },
  setup(__props: any) {



const route = useRoute()
const seriesNumber = computed(() => route.query.series as string)

const onSwiper = (swiper) => {
  if (parseInt(seriesNumber.value)) {
    swiper.slideTo(parseInt(seriesNumber.value) - 1)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Swiper), {
    onInit: onSwiper,
    loop: true,
    slidesPerView: 'auto',
    "space-between": 20,
    class: "slider"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistMedia, (media, index) => {
        return (_openBlock(), _createBlock(_unref(SwiperSlide), {
          "data-hash": `slide${index + 1}`,
          key: `media_${index}`,
          class: "series"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: {name: 'project-player', params: {media: media?.friendly_token}}
            }, {
              default: _withCtx(() => [
                _createVNode(PreviewPlayer, {
                  overlay: false,
                  class: "series__background",
                  media: media
                }, null, 8, ["media"]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(BaseButton, {
                      class: "uppercase",
                      bg: "none",
                      border: "default"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Серия " + _toDisplayString(index + 1), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(media?.title), 1),
                    _createElementVNode("h6", _hoisted_5, _toDisplayString(media?.category), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1032, ["data-hash"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})